import { AxiosRequestHeaders } from 'axios';
import { replace } from 'lodash';
import { SingleHSCodePredictions } from 'src/model/aiHSCodeLabeling';
import { CommonResponseList } from 'src/model/common';
import { getRequest, postRequest, postRequestBlob } from 'src/services/api/http';
import { URL_ENDPOINT } from 'src/utils/constants/service';

function getSinglePrediction(dto: Record<string, string>) {
  const url = URL_ENDPOINT.aiLabeling.instantHSCodePrediction;
  return postRequest(url, dto) as Promise<SingleHSCodePredictions>;
}

function getSentencePrediction(dto: Record<string, string>, image?: Blob) {
  const url = URL_ENDPOINT.aiLabeling.sentenceHSCodePrediction;
  const formData = new FormData();
  if (image && image.size) {
    formData.append('image', image);
  }
  const headers = {
    'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
  } as AxiosRequestHeaders;
  Object.entries(dto).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return postRequest(url, formData, headers) as Promise<SingleHSCodePredictions>;
}

function getHsCodePredictionWithText(dto: Record<string, string>) {
  const url = URL_ENDPOINT.aiLabeling.sentenceHSCodePredictionAISearch;
  return postRequest(url, dto) as Promise<SingleHSCodePredictions>;
}

function getHSCodeDetail(params: { code: string }) {
  const url = URL_ENDPOINT.aiLabeling.hsCodeDetail;
  return getRequest(url, {
    hs_code: params.code,
  }) as Promise<IResponse<ITradeDataAIProductItem>>;
}

function uploadFile(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  const headers = {
    'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
  } as AxiosRequestHeaders;
  const url = URL_ENDPOINT.aiLabeling.uploadFile;
  return postRequest(url, formData, headers) as Promise<IResponse<AIFieldMappingData>>;
}

function mappingField(dto: Record<string, any>) {
  const url = URL_ENDPOINT.aiLabeling.mappingField;
  return postRequest(url, dto) as Promise<IResponse<ExpectedAny>>;
}

function getBulkUploadResult(params: Record<string, any>) {
  const url = replace(URL_ENDPOINT.aiLabeling.getBulkUploadResult, ':id', params.id);
  return getRequest(url, params) as Promise<IResponseList<TypeBulkUploadResult>>;
}
function exportBulkUploadResult(params: Record<string, any>) {
  const url = URL_ENDPOINT.aiLabeling.exportBulkUploadResult;
  return postRequestBlob(url, params) as Promise<Blob>;
}

function getHistoryBulkUpload(params: Record<string, any>) {
  const url = URL_ENDPOINT.aiLabeling.getHistoryBulkUpload;
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<TypeBulkUploadResultHistory>>;
}

const AIService = {
  getSinglePrediction,
  getSentencePrediction,
  getHsCodePredictionWithText,
  uploadFile,
  mappingField,
  getHSCodeDetail,
  getBulkUploadResult,
  exportBulkUploadResult,
  getHistoryBulkUpload,
};

export default AIService;
